import { render } from "./MetricsEditor.vue?vue&type=template&id=179d9e30&scoped=true"
import script from "./MetricsEditor.vue?vue&type=script&lang=js"
export * from "./MetricsEditor.vue?vue&type=script&lang=js"

import "./MetricsEditor.vue?vue&type=style&index=0&id=179d9e30&scoped=true&lang=css"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179d9e30"]])

export default __exports__